import { FCX, ID } from "@datassential/platform-ui-lib";
import { Dispatch, SetStateAction } from "react";
import { useCategoryOptions } from "@core/CommonDataContext";
import { SelectSingle } from "@components/Select";

const SelectVersus: FCX<{
    value: ID;
    setValue: Dispatch<SetStateAction<ID>>;
    categoriesIds: number[];
}> = ({
    value,
    setValue,
    categoriesIds,
    className,
    testId,
}) => {
    const options = useCategoryOptions(categoriesIds);

    return (
        <SelectSingle
            label={<span data-testid="textSelectVersusLabel">VERSUS:</span>}
            value={value}
            setValue={setValue}
            className={className}
            options={options}
            testId={testId}
        />
    );
};

export default SelectVersus;